import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  minutes?: number;
  className?: string;
}
export function CountdownTimer({
  minutes = 10,
  className = ''
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState<number>(minutes * 60);
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
    const storageKey = 'airfryer_offer_end_time';
    const storedEndTime = localStorage.getItem(storageKey);
    const now = new Date().getTime();
    let endTime: number;
    if (storedEndTime && parseInt(storedEndTime) > now) {
      endTime = parseInt(storedEndTime);
    } else {
      endTime = now + minutes * 60 * 1000;
      localStorage.setItem(storageKey, endTime.toString());
    }
    const updateTimer = () => {
      const currentTime = new Date().getTime();
      const difference = Math.max(0, Math.floor((endTime - currentTime) / 1000));
      setTimeLeft(difference);
      if (difference <= 0) {
        // Reset timer when it hits 0 for demo purposes, or keep at 0
        const newEndTime = new Date().getTime() + minutes * 60 * 1000;
        localStorage.setItem(storageKey, newEndTime.toString());
        setTimeLeft(minutes * 60);
      }
    };
    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, [minutes]);
  if (!isClient) return null;
  const hours = Math.floor(timeLeft / 3600);
  const mins = Math.floor(timeLeft % 3600 / 60);
  const secs = timeLeft % 60;
  return <div className={`font-heading font-bold text-red-600 tracking-wider ${className}`} data-id="element-47">
      {hours.toString().padStart(2, '0')}:{mins.toString().padStart(2, '0')}:
      {secs.toString().padStart(2, '0')}
    </div>;
}